export const LocalStorageKeys = {
  noCopyConfirmation: 'no-copy-confirmation',
};
